import axios from "axios";

// withXSRFToken is untyped in axios 1.4 (the locked version) but required from 1.6.1 for
// cross-origin XSRF; keeping the config out of an object literal skips the excess-property check.
const config = {
  baseURL: process.env.NEXT_PUBLIC_CORE_BASEURL,
  headers: {
    Accept: "application/json",
    "X-Requested-With": "XMLHttpRequest",
    origin: process.env.FRONTEND_URL, // This is important for laravel to know where the request is coming from
  },
  withCredentials: true,
  withXSRFToken: true,
};

export const axiosInstance = axios.create(config);

export function ensureCsrfCookie() {
  return axiosInstance.get("/sanctum/csrf-cookie");
}
